import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
// model && interfaces
import Data from '../../../model/Data';
// model imports
import VacancyInterface from '../../../model/Vacancy';
import CityInterface from '../../../model/City';
// styles
import './VacancyPlate.css';

interface Props {
  className?: string;
  city?: CityInterface;
  vacancy: VacancyInterface;
  onClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void
}

class VacancyPlate extends React.Component<Props> {

  private currentClass = 'vacancy-plate';
  
  private city: CityInterface;
  
  constructor(props: Props) {
    super(props);
    const { vacancy } = this.props;
    let { city } = this.props;
    
    if (!city) {
      const cities = vacancy.cities.map((vCity) => Data.Instance.cityById(vCity.id));
      [city] = cities.sort((a, b) => b.weight - a.weight);
    }
    this.city = city;
    this.onClickHandler = this.onClickHandler.bind(this);
  }
  
  onClickHandler(ev: React.MouseEvent<HTMLAnchorElement>): void {
    const { onClick } = this.props;
    if (onClick) onClick(ev);
  }
  
  experienceString(min: number | undefined, max: number | undefined): JSX.Element | null {
    if (!min || !max) return null;
    let years = 'года';
    if (max > 4) years = 'лет';
    return <> &middot; {min}&ndash;{max} {years}</>
  }
  
  render(): JSX.Element {
    const { id, name, uri_alias, area, min_experience, max_experience } = this.props.vacancy;
    const { className } = this.props;
    const klass = {
      [this.currentClass]: true,
      item: true
    };
    
    if (className) klass[className] = true;
    
    return (
      <Link
        to={`/${this.city.uri_alias}/${uri_alias}`}
        key={`${name}-${area}-${this.city}`}
        className={classNames(klass)}
        data-id={id}
        onClick={this.onClickHandler}
      >
        <div className={`${this.currentClass}-inner`}>
          <div className="name">
            { name }
          </div>
          <div className="description">
            { this.city.name }
            { this.experienceString(min_experience, max_experience) }
          </div>
        </div>
      </Link>
    );
  }
}

export default VacancyPlate;
